import { render, staticRenderFns } from "./iocCommonImport.vue?vue&type=template&id=defc2e9c&scoped=true&"
import script from "./iocCommonImport.vue?vue&type=script&lang=js&"
export * from "./iocCommonImport.vue?vue&type=script&lang=js&"
import style0 from "./iocCommonImport.vue?vue&type=style&index=0&id=defc2e9c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defc2e9c",
  null
  
)

export default component.exports